export const TALENT_WORK_RIGHT_REASONS = [
  "EU_EEA_CITIZEN",
  "WORK_RESIDENCE_PERMIT",
  "RESIDENCE_PERMIT_NOT_REQUIRED",
];

export const PASSPORT_CERT_TYPE = "cert013";
export const WORK_RIGHT_CERT_TYPE = "cert012";

// YLPE-2510 later comments say we need to hide passport and work right certificates from customer
// and skill summary
export const CUSTOMER_HIDDEN_CERT_TYPES = [
  PASSPORT_CERT_TYPE,
  WORK_RIGHT_CERT_TYPE,
];

export const DRIVING_LICENSES_CERT_TYPES = [
  "cert001",
  "cert002",
  "cert003",
  "cert004",
  "cert005",
  "cert006",
  "cert007",
  "cert008",
  "cert009",
  "cert010",
  "cert054", // C1 kevyt kuorma-auto
];

export const CRIMINAL_RECORD_EXTRACT_CERT_TYPE = "cert031";

// Types only valid for a fixed period of time, not indefinitely
export const VALID_FOR_FIXED_PERIOD_TYPES = [
  ...DRIVING_LICENSES_CERT_TYPES,
  CRIMINAL_RECORD_EXTRACT_CERT_TYPE,
  PASSPORT_CERT_TYPE,
];

export const LOCAL_STORAGE_KEY = "talentAttachmentsInScan";

export enum TalentContentKey {
  WorkPermits = "workPermits",
  DrivingLicenses = "drivingLicenses",
}

type TalentContentAction = "add" | "edit";

export const getTalentContentKey = (
  key: TalentContentKey,
  action: TalentContentAction,
): string => {
  return `${key}_${action}`;
};
